/* ---------------------------------------------------------------------------
   Site refresh 2026: footer accordions (see refresh-footer.css).
   Below 750px each menu column's H2 wraps a button (aria-expanded) that opens
   and closes its links; one column open at a time, the first open by default.
   From 750px up the button is taken out again and every column shows.
   Without JS the links simply stay open.
   --------------------------------------------------------------------------- */
(() => {
	const PHONE = window.matchMedia("(max-width: 749px)");

	function setOpen(item, open) {
		const button = item.querySelector(".rf-footer__toggle");
		const list = item.querySelector(".rf-footer__links");
		if (button) button.setAttribute("aria-expanded", String(open));
		if (list) list.hidden = !open;
	}

	function toPhone(item) {
		const heading = item.querySelector(".rf-footer__heading");
		const list = item.querySelector(".rf-footer__links");
		if (!heading || !list || heading.querySelector(".rf-footer__toggle")) return;

		const button = document.createElement("button");
		button.type = "button";
		button.className = "rf-footer__toggle";
		button.setAttribute("aria-controls", list.id);
		while (heading.firstChild) button.appendChild(heading.firstChild);
		const icon = document.createElement("span");
		icon.className = "rf-footer__toggle-icon";
		icon.setAttribute("aria-hidden", "true");
		button.appendChild(icon);
		heading.appendChild(button);

		setOpen(item, item.hasAttribute("data-rf-footer-open"));
	}

	function toDesktop(item) {
		const heading = item.querySelector(".rf-footer__heading");
		const button = heading && heading.querySelector(".rf-footer__toggle");
		if (!button) return;

		const icon = button.querySelector(".rf-footer__toggle-icon");
		if (icon) icon.remove();
		while (button.firstChild) heading.appendChild(button.firstChild);
		button.remove();

		const list = item.querySelector(".rf-footer__links");
		if (list) list.hidden = false;
	}

	function sync(root) {
		root.querySelectorAll("[data-rf-footer-acc]").forEach((item) => {
			if (PHONE.matches) toPhone(item);
			else toDesktop(item);
		});
	}

	function init(root) {
		const footer = root.querySelector ? root.querySelector(".rf-footer") : null;
		if (!footer || footer.dataset.rfFooterReady) return;
		footer.dataset.rfFooterReady = "true";

		sync(footer);
		PHONE.addEventListener && PHONE.addEventListener("change", () => sync(footer));

		footer.addEventListener("click", (event) => {
			const button = event.target.closest(".rf-footer__toggle");
			if (!button) return;
			const item = button.closest("[data-rf-footer-acc]");
			const open = button.getAttribute("aria-expanded") !== "true";
			if (open) {
				footer.querySelectorAll("[data-rf-footer-acc]").forEach((other) => {
					if (other !== item) setOpen(other, false);
				});
			}
			setOpen(item, open);
		});
	}

	init(document);

	// Theme editor: the footer section is re-rendered in place
	document.addEventListener("shopify:section:load", (event) => init(event.target));
})();
